<sales-ui-sales-order-item-selector-adapter
  #itemSelectorAdapter
  [selectedApps]="preselectedApps"
  [selectedPackages]="preselectedPackages"
  [config]="{
    partnerId: partnerId,
    marketId: marketId,
    pageSize: 15,
    hideOwnerName: hideOwnerName,
    hideWholesale: !wholesalePricing,
    hideRetail: wholesalePricing,
    hideQuantity: true,
    hideItemsWithOrderForms: hideOrderFormProducts,
    itemTypesAvailable: itemTypesAvailable,
    enforceDependencies: true
  }"
/>
